import React from 'react';
import { dfs } from '../../utils';
import { Modal, Button, Checkbox, ButtonGroup, Tooltip, Select, Input } from '@platform/base';
import { getSysFieldid } from '@platform/api';
import classnames from 'classnames';
import './index.less';

const DEFAULT_INFO = { index: 0, condition: {}, match: false, visible: false };

function getLocationRows(rows, condition, { getColumnProps }, match) {
    if (!condition || !condition.key || !condition.value || !rows || !rows.length) { return []; }
    let rowKeys = [];
    let { itemtype } = getColumnProps(condition.key);
    rows.forEach(row => {
        let cellValue = row.values[condition.key];
        let _display_ = cellValue?._display_ || '';
        let findValue = condition.value;
        if (!match) {
            _display_ = _display_.toLowerCase();
            findValue = findValue.toLowerCase();
        }
        if ((_display_ && _display_.indexOf(findValue) > -1) || (itemtype === 'number' && cellValue.value?.toString()?.indexOf(findValue) > -1)) {
            rowKeys.push(row.key);
        }
    });
    return rowKeys;
}

const { Header, Body, Footer, Title } = Modal;
export default function useLocation(Table) {
    return class LocationTable extends React.Component {

        state = {
            matchWord: false,
            triggeredKey: '', // 触发定位所在列的key
        }

        render() {
            let { columns = [], locationConfig, locale } = this.props;
            const { condition, rows, index: locationIndex, enable, onMatchChange, visible } = locationConfig || {};
            const { matchWord, triggeredKey } = this.state;
            let options = []; //{ key: "0", label:/*locale['please_select']*/"请选择" }
            // 弹窗，可以选择列，同时只能查找一个条件
            // 通过locationConfig.rowKeys 定位行

            if (enable) {
                columns = dfs(columns, col => {
                    if (col.children || !col.locatable) { return col; }
                    options.push({ key: col.key, label: col.label });
                    return {
                        ...col,
                        title: (
                            <>
                                {col.title}
                                <Tooltip
                                    placement="top"
                                    overlay={locale['table0043']}
                                    delayShow={300}
                                >
                                    <i className='header-icon'>
                                        <i className="iconfont icon-dingwei" onClick={() => this.handleIconClick(col)} />
                                    </i>
                                </Tooltip>
                            </>
                        ),
                    };
                });
            }
            return (
                enable ? (<React.Fragment>
                    <Table
                        {...this.props}
                        columns={columns}
                        locationConfig={{
                            ...locationConfig,
                            onLocationClick: this.handleIconClick,
                        }}
                    />
                    <Modal
                        className="location-modal"
                        visible={visible}
                        onCancel={this.closeModal}
                        resizable={false}
                        mask={false}
                        backdrop={false}
                        autoFocus={false}
                        showPosition={{ x: -20, y: 42 }}
                        fieldid="location"
                        zIndex={1000}
                        modalAutoFocus={false} // base-modal里的属性
                        // maskClassName='location-modal-backdrop'
                        onKeyDown={e => {
                            let keyCode = e.keyCode || e.which;
                            if (keyCode !== 13 && keyCode !== 78) { return; }
                            if (e.altKey && keyCode === 78) {
                                //取消
                                e.preventDefault();
                                this.closeModal();
                            } else if (keyCode === 13) {
                                //下一个
                                e.preventDefault();
                                this.handleJumpClick(1);
                            }
                        }}
                    // draggable
                    >
                        <Header closeButton clsPrefix='wui-modal-header'>
                            <Title fieldid='ncModal'>
                                {locale['table0043'] /*定位*/}
                                {
                                    condition?.value ?
                                        <span className='location-tip'>
                                            {rows.length ? `${locale['result'] /*结果*/}：${locationIndex + 1}/${rows.length}`
                                                :
                                                <span className='table-location-tips' title={locale['location_fail_tip']}>
                                                    <span className="iconfont icon icon-gantanhao" />
                                                    <span className="tips-text">{locale['location_fail_tip']/*找不到匹配项，请检查关键字、字段位置或大小写*/}</span>
                                                </span>
                                            }
                                        </span> : ''
                                }
                            </Title>
                        </Header>
                        <Body clsPrefix='wui-modal-body'>
                            <Item
                                key={triggeredKey} // 解决在定位弹窗打开的情况点击另一个列的定位不自动聚焦的问题（key不同，代表不同实例，内部会自动聚焦）
                                item={condition}
                                options={options}
                                onChange={this.handleInfoChange}
                            />

                            <div className='match-case'>
                                <label fieldid={getSysFieldid("location_match_case")}>
                                    {`${locale['location_match_case']}：` /*匹配大小写*/}
                                    <Checkbox
                                        checked={matchWord}
                                        onChange={value => {
                                            onMatchChange?.(value);
                                            this.setState({ matchWord: value });
                                        }}
                                    />
                                </label>
                            </div>
                        </Body>
                        <Footer clsPrefix='wui-modal-footer'>
                            <ButtonGroup>
                                <Button
                                    fieldid="location-prev" //这不对吧？但以前是这么加的
                                    onClick={() => this.handleJumpClick(-1)}
                                    disabled={!rows || rows.length === 0}
                                >{locale['location_previous'] /*上一个*/}</Button>
                                <Tooltip
                                    placement="top"
                                    inverse
                                    overlay={`${locale['location_next'] /*下一个*/}  (Enter)`}
                                    trigger={rows?.length && ['focus', 'hover'] || []}
                                >
                                    <Button
                                        fieldid="location-next" //这不对吧？但以前是这么加的
                                        colors="primary"
                                        onClick={() => this.handleJumpClick(1)}
                                        disabled={!rows || rows.length === 0}
                                        className="wui-button-primary"
                                    >
                                        {locale['location_next'] /*下一个*/}
                                    </Button>
                                </Tooltip>
                            </ButtonGroup>
                            <Tooltip
                                placement="top"
                                inverse
                                overlay={`${locale['table_cancel'] /*取消*/}  (Alt+N)`}
                                trigger={['focus', 'hover']}
                            >
                                <Button
                                    fieldid="location-cancel"
                                    onClick={this.closeModal}
                                >
                                    {locale['table_cancel'] /*取消*/}(<span className="text-decoration-underline">N</span>)
                                </Button>
                            </Tooltip>
                        </Footer>
                    </Modal>
                </React.Fragment>) : <Table {...this.props} />
            );
        }

        handleInfoChange = (key, value) => {
            const { onLocationChange } = this.props.locationConfig || {};
            onLocationChange?.({ key, value });
        }

        handleIconClick = col => {
            const { onLocationChange, onOpen } = this.props.locationConfig || {};
            onLocationChange?.({ key: col.key, value: '' });
            onOpen?.();
            this.setState({ triggeredKey: col.key });

        }

        handleJumpClick = diff => {
            let { onFind, rows, index } = this.props.locationConfig || {};
            if (!rows || !rows.length) { return; } //没有结果，点下一个无效
            if (index + diff >= rows.length) { index = 0; } //超过总个数，从0开始
            else if (index + diff < 0) { index = rows.length - 1; } //超过总个数，从0开始
            else { index += diff; }
            onFind?.(index);
        }

        closeModal = () => {
            const { onClear } = this.props.locationConfig || {};
            onClear?.();
            this.setState({ modalShow: false, matchWord: false });
        }
    };
}
function Item(props) {
    const { options, item = {}, onChange } = props;

    function handleSelectChange(value) {
        onChange?.(value, item.value);
    }

    function handleInputChange(value) {
        onChange?.(item.key, value);
    }

    return (
        <div className="modal-item">
            <Select fieldid={getSysFieldid("location-select")} value={item.key} onChange={handleSelectChange} showClear={false} >
                {
                    options.map(option => (<Select.Option key={option.key}>{option.label}</Select.Option>))
                }
            </Select>
            <Input fieldid={getSysFieldid("location-value")} value={item.value} onChange={handleInputChange} autoFocus={true} showClose={true}></Input>
        </div>

    );
}

useLocation.displayName = 'useLocation';
useLocation.dependence = [];
useLocation.hooks = function () {
    return {
        getLocationInfo: () => {
            return this.store.locationInfo || DEFAULT_INFO;
        },
        setLocationInfo: info => {
            this.store.locationInfo = info;
            this.forceUpdate();
        },
    };
};
useLocation.propsGenerator = function (props) {
    const { locationConfig } = props;
    if (!locationConfig?.enable) {
        return props;
    }

    let { store } = props;
    let rows = store.getVisibleRows();
    let info = store.getLocationInfo();

    return {
        ...props,
        cellProps: (rowInfo, colInfo) => {
            let rawCellProps = props.cellProps?.(rowInfo, colInfo) || {};

            if (!info?.rows || !info.rows.length) { return rawCellProps; }

            let rowsSet = new Set(info.rows);
            if (rowsSet.has(rowInfo.row.key) && colInfo.col.key === info?.condition?.key) {
                return {
                    ...rawCellProps,
                    className: classnames(
                        'location-cell',
                        { current: rowInfo.row.key === info.rows[info.index] },
                        rawCellProps.className,
                    ),
                };
            }
            return rawCellProps;
        },
        locationConfig: {
            ...info,
            ...locationConfig,
            onLocationChange: condition => {
                let info = store.getLocationInfo();
                let locationRows = getLocationRows(rows, condition, store, info.match);
                info = { ...info, condition, rows: locationRows, index: 0 };
                store.setLocationInfo(info);
                if (locationRows.length) {
                    store.scrollIntoView({ rowKey: info.rows[info.index], colKey: info.condition.key });
                }
                locationConfig?.onLocationChange?.(condition);
            },
            onFind: index => {
                let info = store.getLocationInfo();
                if (!info.rows?.length) { return; }
                info = { ...info, index };
                store.setLocationInfo({ ...info, index });
                store.scrollIntoView({ rowKey: info.rows[info.index], colKey: info.condition.key });
                locationConfig?.onFind?.(index, info.rows[info.index], info.condition.key);
            },
            onMatchChange: match => {
                let info = store.getLocationInfo();
                let locationRows = getLocationRows(rows, info.condition, store, match);
                info = { ...info, match, rows: locationRows };
                store.setLocationInfo(info);
                if (locationRows.length) {
                    store.scrollIntoView({ rowKey: info.rows[info.index], colKey: info.condition.key });
                }
                locationConfig?.onMatchChange?.(match);
            },
            onClear: () => {
                store.setLocationInfo(DEFAULT_INFO);
                locationConfig?.onClear?.();
            },
            onOpen: () => {
                store.setLocationInfo({ ...store.getLocationInfo(), visible: true });
            },
        },
    };
};